/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Type_LabelInputs */

const he_notifications_type_label = /** @type {(inputs: Notifications_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סוג ההתראה`)
};

const en_notifications_type_label = /** @type {(inputs: Notifications_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Type`)
};

/**
* | output |
* | --- |
* | "Notification Type" |
*
* @param {Notifications_Type_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_type_label = /** @type {((inputs?: Notifications_Type_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Type_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_type_label(inputs)
	return en_notifications_type_label(inputs)
});